import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import { numericInputPattern, preventMaxInput } from "utils/validations";
import formValidation from "../../utils/formValidation";
import ErrorMessage from "components/ErrorMessage";

const StateAdd = ({ allState, handleCategory }) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const notification = useToastContext();
  const [cat, setCat] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      stateCode: "+",
    },
  });
  const handleSubmitForm1 = async (data) => {
    try {
      const payload = {
        countryID: cat,
        name: data?.name?.trim(),
        stateCode: data?.stateCode.slice(1),
      };
      const res = await apiPost(apiPath.stateAdd, payload);
      if (res?.data?.success) {
        allState();
        handleCategory(false);
        notification.success(res.data?.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const handleDecimalOffer = (e) => {
    var value = e.target.value;
    setValue("stateCode", "+" + value.slice(1));
  };
  const selectCategoryCountry = (e) => {
    if (e.target.value) {
      setCat(e.target.value);
      clearErrors("countryID");
    } else {
      setCat("");
      setError("countryID", {
        type: "validation",
        message: "Please select country.",
      });
    }
  };

  const getCountryList = async () => {
    try {
      const res = await apiGet(apiPath.getCountryList, {});
      setCountries(res?.data?.results?.allCountries || []);
    } catch (error) {
      console.log("error:", error);
    }
  };

  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <>
      <div className="overflow-x-hidden overflow-y-auto fixed inset-0 justify-center items-center flex z-50 outline-none focus:outline-none">
        <div className="relative mx-auto max-w-3xl w-auto my-6">
          <div className="sm:px-2 sm:py-8 px-7 md:py-4">
            <div className="border-0 rounded-lg flex-col w-full bg-white shadow-lg relative flex outline-none focus:outline-none min-w-[750px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("ADD_STATE")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none">
                  <span
                    title="Close"
                    className=" text-[#B8BBBF] text-4xl"
                    onClick={() => handleCategory(false)}
                  >
                    ×
                  </span>
                </button>
              </div>
              <form method="post" onSubmit={handleSubmit(handleSubmitForm1)}>
                <div className="flex-auto relative p-6">
                  <div className="grid grid-cols-2">
                    <div className="px-7 md:py-4 sm:px-2 sm:py-8">
                      <div className="group relative z-0 w-full">
                        <select
                          className="border-2 block py-4 px-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          type="select"
                          id="countryID"
                          value={cat}
                          {...register("countryID", {
                            required: "Please select country name.",
                          })}
                          onChange={selectCategoryCountry}
                        >
                          <option value="">{t("SELECT_COUNTRY")}</option>
                          {countries.map((item) => (
                            <option key={item?._id} value={item?._id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                        <label
                          htmlFor="countryID"
                          className="text-[#A5A5A5] dark:text-gray-400 duration-300 peer-focus:font-normal absolute text-sm transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {" "}
                          {t("COUNTRY")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.countryID?.message} />
                      </div>
                    </div>
                    <div className="md:py-4 px-7 sm:px-2 sm:py-8">
                      <div className="relative z-0 w-full group">
                        <OInputField
                          name="name"
                          id="name"
                          wrapperClassName="relative w-full z-0  group"
                          type="text"
                          inputLabel={
                            <>
                              {t("STATE")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          placeholder=""
                          onInput={(e) => preventMaxInput(e, 30)}
                          maxLength={30}
                          register={register(
                            "name",
                            formValidation["stateName"]
                          )}
                          errors={errors}
                        />
                      </div>
                    </div>
                    <div className="md:py-4 px-7 sm:px-2 sm:py-8">
                      <div className="relative z-0 w-full group">
                        <OInputField
                          name="code"
                          id="code"
                          wrapperClassName="relative w-full z-0 group"
                          type="text"
                          inputLabel={
                            <>
                              {t("2-letter State Code")}
                              <span className="text-red-500">*</span> {/* 👈 ADDED RED ASTERISK */}
                            </>
                          }
                          placeholder="e.g. AR"
                          onInput={(e) => {
                            e.target.value = e.target.value.toUpperCase();
                            preventMaxInput(e, 2); 
                          }}
                          maxLength={2}
                          register={register("code", {
                            required: "Abbreviation / Code is required", // 👈 ADDED REQUIRED VALIDATION
                            pattern: {
                              value: /^[A-Z0-9]*$/,
                              message: "Only uppercase letters and numbers allowed"
                            }
                          })}
                          errors={errors}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="border-t border-solid flex items-center justify-center p-6 border-slate-200 rounded-b">
                  <button
                    type="button"
                    onClick={() => handleCategory(false)}
                    className="font-normal px-12 py-2.5 text-black bg-[#E1E1E1] text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  >
                    {t("O_BACK")}
                  </button>

                  <button
                    type="submit"
                    className="rounded shadow hover:shadow-lg outline-none bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 focus:outline-none mr-1  ease-linear transition-all duration-150"
                  >
                    {t("O_ADD")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default StateAdd;